export const filterType = {
  last30Days: 'last30Days',
  last90Days: 'last90Days',
  last12Months: 'last12Months',
  custom: 'custom',
}

export const filterOptions = [
  {
    name: 'Last 30 Days',
    value: 'last30Days',
  },
  {
    name: 'Last 90 Days',
    value: 'last90Days',
  },
  {
    name: 'Last 12 Months',
    value: 'last12Months',
  },
  {
    name: 'Custom',
    value: 'custom',
  },
];